import { FEED_PUB_HEADER } from 'app/appConstants';
import { MprcContainer, MprcFormBarHeader } from 'components';
import { ButtonBack } from 'components/buttons';
import React from 'react';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    actions?: React.ReactNode[];
    onClose: () => void;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Header da página de contéudo da publicação
 * @param props
 */
export const PublicationHeader: React.FC<IProps> = (props) => {

    const { actions, onClose } = props;

    var headerItems: React.ReactNode[] = [<ButtonBack rounded size="large" variant="text" onClick={() => onClose()} />];

    if (actions && actions.length > 0)
        headerItems = [...headerItems, ...actions];

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <MprcContainer id={FEED_PUB_HEADER}>
            <MprcFormBarHeader actions={headerItems} />
        </MprcContainer>
    );
};
